import React from 'react';
import {Popover as Base, PopoverBody} from 'reactstrap';
import {PopoverProps} from 'reactstrap/types/lib/Popover';

export default function Popover({itemRef, children, ...props}: Omit<PopoverProps, 'target'> & {
    itemRef: React.RefObject<HTMLElement>,
    children?: React.ReactNode,
}) {
    return <Base target={itemRef} {...props}>
        <PopoverBody>{children}</PopoverBody>
    </Base>;
}
